import ProfileClaim from './ProfileClaim.container';

export default ProfileClaim;
